import { options_common_invalidIsSelfError } from 'owa-locstrings/lib/strings/options_common_invalidisselferror.locstring.json';
import { options_common_invalidDomainError } from 'owa-locstrings/lib/strings/options_common_invaliddomainerror.locstring.json';
import { options_common_invalidAddressOrDomainError } from 'owa-locstrings/lib/strings/options_common_invalidaddressordomainerror.locstring.json';
import { options_common_invalidAddressError } from 'owa-locstrings/lib/strings/options_common_invalidaddresserror.locstring.json';
import loc from 'owa-localize';
import { assertNever } from 'owa-assert';
import { getUserConfiguration } from 'owa-session-store';
import { isValidAddress, isValidAddressDomain } from 'owa-mail-option-common/lib/utils/smtpAddress';
import * as trace from 'owa-trace';

export const enum ValidationResult {
    OK,
    InvalidAddress,
    InvalidAddressOrDomain,
    InvalidDomain,
    IsSelf,
}

export const enum EditSendersAndDomainsMode {
    EmailAddressOnly,
    DomainOnly,
    EmailAddressAndDomain,
    EmailAddressOnlyAllowSelf,
}

function isSelf(smtpAddress: string) {
    const sessionSettings = getUserConfiguration().SessionSettings;
    const userEmailAddress = sessionSettings.UserEmailAddress;
    const lowerCaseSmtpAddress = smtpAddress.toLowerCase();
    if (!userEmailAddress) {
        trace.errorThatWillCauseAlert('User email address from session data is null.');
    }
    return (
        userEmailAddress.toLowerCase() === lowerCaseSmtpAddress ||
        (sessionSettings.UserProxyAddresses &&
            sessionSettings.UserProxyAddresses.some(
                address => address.toLowerCase() === lowerCaseSmtpAddress
            ))
    );
}

export default function validateSenderOrDomain(mode: EditSendersAndDomainsMode, text: string) {
    const trimmedText = text.trim();
    switch (mode) {
        case EditSendersAndDomainsMode.DomainOnly:
            return validateDomain(trimmedText);
        case EditSendersAndDomainsMode.EmailAddressOnly:
            return validateEmailAddress(trimmedText);
        case EditSendersAndDomainsMode.EmailAddressAndDomain:
            if (
                validateEmailAddress(trimmedText) == ValidationResult.OK ||
                validateDomain(trimmedText) == ValidationResult.OK
            ) {
                return ValidationResult.OK;
            } else {
                return ValidationResult.InvalidAddressOrDomain;
            }
        case EditSendersAndDomainsMode.EmailAddressOnlyAllowSelf:
            const result = validateEmailAddress(trimmedText);
            return result == ValidationResult.OK || result == ValidationResult.IsSelf
                ? ValidationResult.OK
                : result;
        default:
            return assertNever(mode);
    }
}

function validateEmailAddress(text: string) {
    if (isSelf(text)) {
        return ValidationResult.IsSelf;
    }
    return isValidAddress(text) ? ValidationResult.OK : ValidationResult.InvalidAddress;
}

function validateDomain(text: string) {
    return isValidAddressDomain(text) ? ValidationResult.OK : ValidationResult.InvalidDomain;
}

export function validationErrorMessage(result: ValidationResult) {
    switch (result) {
        case ValidationResult.OK:
            throw new Error('validationErrorMessage called for OK');
        case ValidationResult.InvalidAddress:
            return loc(options_common_invalidAddressError);
        case ValidationResult.InvalidAddressOrDomain:
            return loc(options_common_invalidAddressOrDomainError);
        case ValidationResult.InvalidDomain:
            return loc(options_common_invalidDomainError);
        case ValidationResult.IsSelf:
            return loc(options_common_invalidIsSelfError);
        default:
            return assertNever(result);
    }
}
